import {call, put, select} from 'redux-saga/effects';
import {editPubBeer} from 'services/pubs';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';

import {editPubBeerACS, getPubBeersACS} from '../requestAC';

export function* editPubBeerSaga(action: ReturnType<typeof editPubBeerACS>) {
  const {pubBeerFilters} = yield select((state) => state.beersManager);
  const managedPubId: string = yield select((state) => state.managedPub.managedPub.id);

  try {
    yield call(editPubBeer, {dto: action.payload, pubId: managedPubId});
    yield put(getPubBeersACS({pubId: String(managedPubId), ...pubBeerFilters}));
    yield put(setSuccessAC('Beer successfully edited'));
  } catch (error) {
    yield call(handleError, error, 'Failed to edit beer.');
  }
}
